import { useRef, useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import * as compSettings from "./settings";

const getSliderDimensions = (aspectRatio = 1) => {
  const width = window.innerWidth;
  return { width, height: width * aspectRatio };
};

const BannerSlider = ({ id, extendedSettings }) => {
  const navigate = useNavigate();

  const settings = {
    ...compSettings,
    ...extendedSettings?.[id],
  };

  // Settings'ten değerleri al
  const aspectRatio = settings.aspectRatio.value;
  const padding = settings.padding.value + "px";
  const borderRadius = settings.borderRadius.value + "px";
  const autoScroll = settings.autoScroll.value;
  const autoScrollInterval = settings.autoScrollInterval.value;
  const smoothScroll = settings.smoothScroll.value;
  const snapEnabled = settings.snapEnabled.value;
  const objectFit = settings.objectFit.value;
  const backgroundColor = settings.backgroundColor.value;
  const banners = JSON.parse(settings?.items?.value);
  const titleTextColor = settings.titleTextColor.value;
  const titleFontSize = settings.titleFontSize.value;
  const titleFontWeight = settings.titleFontWeight.value;
  const titleTextAlign = settings.titleTextAlign.value;

  const bannerSubtitleTextColor = settings.bannerSubtitleTextColor.value;
  const bannerSubtitleFontSize = settings.bannerSubtitleFontSize.value;
  const bannerSubtitleFontWeight = settings.bannerSubtitleFontWeight.value;
  const bannerSubtitleTextAlign = settings.bannerSubtitleTextAlign.value;


  const bannerDescriptionTextColor = settings.bannerDescriptionTextColor.value;
  const bannerDescriptionFontSize = settings.bannerDescriptionFontSize.value;
  const bannerDescriptionFontWeight = settings.bannerDescriptionFontWeight.value;
  const bannerDescriptionTextAlign = settings.bannerDescriptionTextAlign.value;

  const bannerLinkTextColor = settings.bannerLinkTextColor.value;
  const bannerLinkFontSize = settings.bannerLinkFontSize.value;
  const bannerLinkFontWeight = settings.bannerLinkFontWeight.value;

  const showBannerSubtitle = settings.showBannerSubtitle?.value;
  const showBannerDescription = settings.showBannerDescription?.value;
  const showBannerLink = settings.showBannerLink?.value;

  const bannerSubtitleText = settings.bannerSubtitleText.value;
  const bannerDescriptionText = settings.bannerDescriptionText.value;
  const bannerLinkText = settings.bannerLinkText.value;
  const bannerTextGap = settings.bannerTextGap.value;
  const [current, setCurrent] = useState(0);
  const [dimensions, setDimensions] = useState(
    getSliderDimensions(aspectRatio)
  );
  const sliderRef = useRef(null);

  //TODO: Implement click handler
  //TODO: Implement infinite scroll
  //TODO: Implement auto-scroll

  const onBannerClick = (banner) => {
    navigate(`/category`, {
      state: { id: banner.id, name: banner.label },
    });
  };

  const handleResize = useCallback(() => {
    setDimensions(getSliderDimensions(aspectRatio));
  }, [aspectRatio]);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  useEffect(() => {
    const onScroll = () => {
      if (!sliderRef.current) return;
      const scrollLeft = sliderRef.current.scrollLeft;
 const width = sliderRef.current.offsetWidth;
       const newIndex = Math.round(scrollLeft / width);
      if (newIndex !== current) {
        setCurrent(newIndex);
      }
    };
    const ref = sliderRef.current;
    if (!ref) return;

    ref.addEventListener("scroll", onScroll, { passive: true });
    return () => ref.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (!autoScroll || banners.length < 2) return;
    const timer = setTimeout(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, autoScrollInterval * 1000);
    return () => clearTimeout(timer);
  }, [current, banners.length, autoScroll, autoScrollInterval]);


  return (
    <div style={{ width: "100%" }}>
      <div
        ref={sliderRef}
        style={{
          width: "100%",
          overflowX: "auto",
          display: "flex",
          scrollSnapType: snapEnabled ? "x mandatory" : "none",
          height: dimensions.height,
          scrollBehavior: smoothScroll ? "smooth" : "auto",
          backgroundColor: backgroundColor,
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >

        {banners.map((banner) => (
          <div
            onClick={() => onBannerClick(banner)}
            key={banner.id}
            style={{
              boxSizing: "border-box",
              flexShrink: 0,
              width: dimensions.width,
              height: dimensions.height,
              scrollSnapAlign: snapEnabled ? "center" : "none",
              padding: padding,
              position: "relative",
            }}
          >
            <h3 style={{
              color: titleTextColor,
              fontSize: titleFontSize,
              fontWeight: titleFontWeight,
              textAlign: titleTextAlign,
            }}>Başlık</h3>
            <img
              src={banner.img}
              alt={banner.altText}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                userSelect: "none",
                pointerEvents: "none",
                borderRadius: borderRadius,
                overflow: "hidden",
                display: "block",
              }}
              draggable={false}
            />
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                display: "flex",
                flexDirection: "column",
                gap: bannerTextGap,
                transform: "translate(-50%, -50%)",
                width: "80%",
                textAlign: "center",
              }}
            >
              {showBannerSubtitle && (
                <h4
                  style={{
                    color: bannerSubtitleTextColor,
                    fontSize: bannerSubtitleFontSize,
                    fontWeight: bannerSubtitleFontWeight,
                    textAlign: bannerSubtitleTextAlign,
                    margin: 0,
                  }}
                >
                  {bannerSubtitleText}
                </h4>
              )}
              {showBannerDescription && (
                <p
                  style={{
                    color: bannerDescriptionTextColor,
                    fontSize: bannerDescriptionFontSize,
                    fontWeight: bannerDescriptionFontWeight,
                    textAlign: bannerDescriptionTextAlign,

                  }}
                >
                  {bannerDescriptionText}
                </p>
              )}
              {showBannerLink && (
                <a
                  href="/category"
                  style={{
                    display: "inline-block",

                    color: bannerLinkTextColor,
                    fontSize: `${bannerLinkFontSize}px`,
                    fontWeight: bannerLinkFontWeight,

                    textDecoration: "underline",
                    cursor: "pointer",
                    transition: "color 0.3s ease",
                  }}

                >
                  {bannerLinkText}
                </a>
              )}
            </div>
          </div>
        ))}

      </div>
      <div
        style={{
          display: "flex",
          gap: 8,
          justifyContent: "center",
          alignItems: "center",
          marginTop: 12,
          paddingBottom: 4,
          userSelect: "none",
        }}
      >
        {banners.map((_, i) => {
          const isActive = i === current;
          return (
            <button
              key={`dot-${i}`}
              onClick={() => setCurrent(i)}
              aria-label={`Slide ${i + 1}`}
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                border: "none",
                outline: "none",
                cursor: "pointer",
                backgroundColor: isActive ? "#111" : "rgba(0,0,0,0.25)",
                transform: isActive ? "scale(1.2)" : "scale(1)",
                transition: "transform 200ms ease, background-color 200ms ease",
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default BannerSlider;
